import { Button } from '../../components/Button';

interface EditTripActionsProps {
  hasUnpublishedChanges: boolean;
  isPublishing: boolean;
  onPublish: () => void;
  viewTripUrl?: string;
}

/**
 * Presentational component for edit trip action buttons.
 * Shows publish and view trip buttons.
 */
export const EditTripActions = ({
  hasUnpublishedChanges,
  isPublishing,
  onPublish,
  viewTripUrl,
}: EditTripActionsProps) => {
  return (
    <div className="relative mt-8 mb-8 max-w-7xl mx-auto px-4 md:px-8">
      <div className="flex justify-center gap-3">
        <Button
          variant="primary"
          disabled={!hasUnpublishedChanges || isPublishing}
          loading={isPublishing}
          title={
            hasUnpublishedChanges
              ? isPublishing
                ? 'Publishing...'
                : 'Publish your changes'
              : 'Already up-to-date'
          }
          onClick={onPublish}
        >
          {isPublishing ? 'Publishing...' : 'Publish Changes'}
        </Button>
        {viewTripUrl && (
          <Button variant="secondary" title="View your trip" href={viewTripUrl}>
            View Trip
          </Button>
        )}
      </div>
    </div>
  );
};
